import type { AuthContent } from '@nebula-shared/domain';

/**
 * Extrae AuthContent del envelope Simappe (`response.content`) o de un body plano.
 * Devuelve null si el 200 no trae `accessToken` usable.
 */
export function extractAuthContentFromRefreshResponse(response: unknown): AuthContent | null {
  if (!response || typeof response !== 'object') {
    return null;
  }
  const root = response as Record<string, unknown>;
  const envelope = root['response'];
  if (envelope && typeof envelope === 'object') {
    const content = (envelope as Record<string, unknown>)['content'];
    if (content && typeof content === 'object') {
      const auth = content as AuthContent;
      if (typeof auth.accessToken === 'string' && auth.accessToken.length > 0) {
        return auth;
      }
    }
  }
  if (typeof root['accessToken'] === 'string' && (root['accessToken'] as string).length > 0) {
    return root as unknown as AuthContent;
  }
  return null;
}
